import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as routeBound from '../../../route-bound'

import * as me from '../../../me'

import { Api } from './api.service'
import type { TypeParams } from './types'

/**
 * Job Titles collection for fetching space job titles
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: jobTitle => jobTitle.id,
      name: ec.Name.Predefined.SpaceJobTitle,
      plugins: {
        additionalFactories: [
          new ds.input.select.singleEc.ec.Factory<TypeParams>({
            getItem: ({ name, id }) => ({
              label: name,
              value: id,
            }),
          }),
        ],
      },
    })
  }
}
